<template>
  <div id="scheduleBox" class="statv_wrapper">
    <h3 class="disabled"> SCHEDULE </h3>
    <div class="schedule_header" v-show="sortedSchedules.length > 0">
      <p class="title"> 
        <!-- <span> TODAY'S </span>  -->
        <span> ON AIR </span> 
      </p>
      <div class="link_detail"> 
        <a @click.prevent="$router.push('/schedule').catch(e => {})"> 편성표 보기 </a> 
      </div>
    </div>
    <Slick ref="schduleSlick" class="schedule_slick" :options="slickOptions">
      <div class="schedule_box" v-for="schedule in sortedSchedules" :key="schedule.id">
        <div class="schedule_item" :class="{'now': schedule.now}">
          <div class="schedule_time"> 
            <p class="cell1"> {{schedule.now ? 'NOW' : isBeforeTime(schedule.time) ? 'NEXT' : 'PREV'}} </p>
            <p class="cell2"> {{schedule.time}} </p>
            <p class="cell3 badge" :class="rowClassName(schedule.type)"></p>
			  <div v-if="isMobile" class="m_next_btn" @click.prevent="next"> NEXT </div>
          </div>
          <div class="schedule_contents">
            {{schedule.content}}
          </div>
        </div>
      </div>
    </Slick>
  </div>
</template>
<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import $ from "jquery";
import moment from "moment";
import _ from "lodash";
import Utils from "@/helpers/utils.js";
import * as Store from '@/store/modules/schedule';

export default {
  name: "ScheduleBox",
  components: {
    Slick
  },
  	data() {
		return {
			// schedules: [],
			searchDate: "",
			isMobile: false,
			slickOptions: {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 500,
        autoplaySpeed: 5000,
        arrows: true,
        prevArrow: '<button class="slick-arrow slick-prev"></button>',
        nextArrow: '<button class="slick-arrow slick-next"></button>',
        // responsive: [{
        // 			breakpoint: Utils.getSize().MOBILE,
        // 			settings: {
        // 				slidesToShow: 1,
        // 				slidesToScroll: 1,
        // 				// centerMode: true
        // 			}
        // 		}]
			}
		}
	},
	computed: {
		...Store.mapState([
		'schedules'
	]),
    sortedSchedules() {
      let temp = [];
      let size = _.size(this.schedules);
      let startIndex = _.findIndex(this.schedules, {'now': true});
      //now 없을 경우 return
      if(_.isEqual(startIndex, -1)) return this.schedules;
      //현재 방영중인 데이터 먼저 정렬
      for(let i = startIndex; i < size + startIndex; i++){
        let idx = i >= size ? i - size : i;
        temp.push(this.schedules[idx]);
      }
      return temp;
    }
  },
  async created() { 
	this.isMobile = Utils.isMobile()
    this.searchDate = moment().format("YYYY-MM-DD");
	// this.searchDate = moment('2020-02-17').format("YYYY-MM-DD");
	this.slickOptions.slidesToShow = this.isMobile ?  1 : 3
    // await this.loadSchedules();
    await this.getSchedules(this.searchDate);
  },
  watch: {

  },
  updated() {
    this.$nextTick(function() {
      if(this.$refs.schduleSlick) {
        this.$refs.schduleSlick.create(this.slickOptions);
      }
    })
  },
  beforeUpdate() {
    if (this.$refs.schduleSlick) {
        this.$refs.schduleSlick.destroy();
    }
  },
  beforeDestroy() {
    if (this.$refs.schduleSlick) {
        this.$refs.schduleSlick.destroy();
    }
  },
  methods: {
    ...Store.mapActions([
      'getSchedules'
    ]),
    rowClassName(type) {
        let list = {   "재방송":  "reaplay", "생방송":  "live", "본방송":  "air" }
        return _.has(list, type) ? list[type] : ""
	},
	isBeforeTime(time) {
		let now = moment()
		return now.isBefore(moment(time, "HH:mm"), 'HH:mm')
	},
	next() {
		this.$refs.schduleSlick.next();
	}
    /* async loadSchedules() {
      await this.$axios.get(`/api/schedule/${this.searchDate}`).then(
        response => {
          if(_.isEqual(response.status, 200)) {
            if(_.size(response.data) > 0) {
              let responseDate = response.data[0]['date'];
              if(!_.eq(this.searchDate, responseDate)) { 
                return false;
              }
              this.schedules = _.forEach(response.data, (v) => {
                  v['time'] = moment(v['time'], 'HH:mm').format("HH:mm");
                  return v;
              });
              this.schedules = this.sortData(this.schedules);
            }
          }
      });
    },
    sortData(data) {
      let temp = [];
      let size = _.size(data);
      let startIndex = _.findIndex(data, {'now': true});
      //now 없을 경우 return
      if(_.isEqual(startIndex, -1)) return new Array;
      //현재 방영중인 데이터 먼저 정렬
      for(let i = startIndex; i < size + startIndex; i++){
        let idx = i >= size ? i - size : i;
        temp.push(data[idx]);
      }
      return temp;
    }, */
    // reDrawSlick(n) {
    //   this.slickOptions.slidesToShow = n ? 1 : 3;
    //     this.slickOptions.slidesToScroll = n ? 1 : 3;
    //     if (this.$refs.schduleSlick) {
    //       this.$refs.schduleSlick.destroy();
    //       this.$refs.schduleSlick.create(this.slickOptions);
    //     }
    // }
  }
}
</script>
<style lang="less">
#scheduleBox {
  min-height: 170px;
  margin: auto;
  .schedule_header {
    position :relative;
    display: flex;
    width: 100%;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    letter-spacing: 0;
    margin-bottom: 7px;
    color: #ff0043;
    .title {
      font-size: 36px;
      font-weight: normal;
      > span:first-child {
				font-family: "BebasNeue_Thin";
			}
      > span:last-child {
        font-family: "BebasNeue";
      }
    }
    .link_detail {
      position: absolute;
      display: block;
      font-size: 18px;
      font-weight: 400;
      z-index: 1;
      right: 0;
      cursor: pointer;
      &::after {
        content: ">";
      }
    }
  }
  .schedule_slick {
    position: relative;
    width: 100%;
    .slick-slide,
    .slick-slide.slick-active {
      &[data-slick-index='0'] {
        .schedule_item {
          margin-right: 3px;
        }
      }
      &[data-slick-index='1'] {
        .schedule_item {
          margin-left: 3px;
          margin-right: 3px;
        }
      }
      &[data-slick-index='2'] {
        .schedule_item {
          margin-left: 3px;
        }
      }
      .schedule_item {
        display: flex;
        flex-flow: column nowrap;
        width: 356px;
        height: 100px;
        text-align: left;
        color: #ff0043;
	      background-color: #FEE8DF;
        &.now {
		      background-color: #ff0043;
          color: #FFFFFF;
          .cell1 {
            color: #FFFF8C !important;
            font-size: 30px;
            font-family: "BebasNeue";
          }
          .cell2 {
            height: 100%;
          }
        }
        .schedule_time {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          padding: 12px;
          height: 30px;
          font-family: "BebasNeue_Thin";
          .cell1 {
            font-size: 30px;
            margin-right: 10px;
          }
          .cell2 {
            font-size: 24px;
            margin-right: 5px;
          }
          .cell3 {

          }
        }
        .schedule_contents {
          padding: 5px 12px;
          font-size: 20px;
          font-weight: 900;
          word-break: break-all;
          text-overflow:ellipsis;
          white-space:nowrap;
          overflow: hidden;
          transform: skew(0.5deg);
          letter-spacing: 0;
        }
      }
    }

    //slick arrow style
    .slick-next {
      background-image: url("~@/assets/image/schedule/arrow_right.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      right: -30px;
    }

    .slick-prev {
      background-image: url("~@/assets/image/schedule/arrow_left.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      left: -30px;
    }

    .slick-arrow {
      position: absolute;
      width: 12px;
      height: 32px;
      margin: auto;
      top: 0;
      bottom: 0;
      border: none;
      cursor: pointer;
      vertical-align: middle;
      background-color:rgba(0, 0, 0, 0);
    }
  }
}

.m #scheduleBox {
	.schedule_header {
		margin-bottom: 15px;
		.title {
			font-size: 50px;
		}
		.link_detail {
			display: none;
		}
	}
  .schedule_slick {
	  .slick-slide,
		.slick-slide.slick-active {
			&[data-slick-index='1'] {
				.schedule_item {
					// margin: 0;
				}
			}
		}
		.slick-slide {
			.schedule_item {
				width: 100%;
				height: 130px;
				margin: 0 2px;
				&.now {
					width: 99%;
					.schedule_time {
						.cell1 {
							font-size: 44px;
						}
						.m_next_btn {
							color: #FFFFFF;
							&::after {
								background-image: url("~@/assets/image/home/arrow_next_white_m@2x.png");
							}
						}
					}
				}
				.schedule_time {
          position: relative;
          height: 45px;
					.cell1 {
						font-size: 44px;
					}
					.cell2 {
						font-size: 36px;
						line-height: 1.2;
					}
					.cell3 {
						width: 25px;
						height: 25px;
					}
					.m_next_btn {
						position: absolute;
						font-family: 'BebasNeue_Thin';
						right: 40px;
						font-size: 44px;
						color: #ff0043;
						&::after {
							content: "";
							position: absolute;
							width: 20px;
							height: 20px;
							right: -25px;
              top: 0;
              bottom: 5px;
              margin: auto;
							display: block;
							background-image: url("~@/assets/image/board/arrow_right.png");
							background-repeat: no-repeat;
							background-size: 15px 16px;
              background-position: center;
						}
					}
				}
				.schedule_contents {
					font-size: 30px;
				}
			}
		}
  	}
}
</style>